import { TromanError } from "../../common/TromanError";

const MINUTES_PER_DAY = 24 * 60;
const retime = /^([01]?[0-9]|2[0-4])([:.]([0-5][0-9]))?$/;

function parseTime(value, isEnd) {
    var str = value.trim();
    var m = str.match(retime);
    if (!m) throw new Error('Parse failed');

    let time = parseInt(m[1], 10) * 60;
    if (m[3]) {
        time = time + parseInt(m[3], 10);
    }

    if (time > MINUTES_PER_DAY || (time == MINUTES_PER_DAY && !isEnd)) {
        throw new Error('Parse failed');
    }

    return time;
}

function formatMinutes(min) {
    var h = Math.trunc(min / 60);
    var m = min % 60;

    var ret = "";
    if (h < 10) ret = "0";
    ret += h.toFixed(0);
    ret += ":";
    if (m < 10) ret += "0";
    ret += m.toFixed(0);

    return ret;
}

function formatInterval(iv) {
    let ret = formatMinutes(iv.start);
    if (iv.end != null) {
        ret += '-';
        if (iv.end > MINUTES_PER_DAY) {
            let adjusted = iv.end - MINUTES_PER_DAY;
            if (adjusted > iv.start) {
                ret += formatMinutes(iv.last);
                ret += ', ';
                ret += formatMinutes(iv.last);
                ret += '-';
            }
            ret += formatMinutes(adjusted);
        } else {
            ret += formatMinutes(iv.end);
        }
    }
    return ret;
}

function compareInterval(a, b) {
    if (a.start === b.start) {
        if (a.end == null) return b.end == null ? 0 : 1;
        if (b.end == null) return -1;
        return a.end - b.end;
    }
    return a.start - b.start;
}

function parseInterval(start, end) {
    let stime = parseTime(start);
    let etime = parseTime(end, true);

    if (etime < stime) {
        etime = etime + MINUTES_PER_DAY;
    }

    return {
        start: stime,
        end: etime,
        last: etime < MINUTES_PER_DAY ? etime : stime
    };
}

function parseIntervals(str) {
    let ivs = [];
    var source = String(str || '').trim();
    if (source.length > 0) {
        for (let sourceInterval of source.split(',')) {
            let parts = sourceInterval.split('-');
            if (parts.length == 1) {
                ivs.push({ start: parseTime(parts[0]) });
            } else if (parts.length == 2) {
                ivs.push(parseInterval(parts[0], parts[1]));
            } else {
                throw new TromanError('parse_timestring', 'Felaktigt formaterad tidsangivelse.');
            }
        }
    }
    return ivs;
}

export class TimeString {
    constructor(source) {
        this.isClosed = true;

        let ivs = parseIntervals(source);
        ivs.sort(compareInterval);

        let prev = null;
        let acc = [];
        let dur = 0;
        for (let ii = 0; ii < ivs.length; ++ii) {
            const iv = ivs[ii];
            if (iv.end == null) {
                this.isClosed = false;
                acc.push(iv);
            } else {
                // Does iv overlap the previous entry?
                if (prev != null && iv.start <= prev.end) {
                    // Update last time today
                    if (iv.last > prev.last) {
                        prev.last = iv.last;
                    }

                    // Extend the previous interval
                    if (iv.end > prev.end) {
                        dur = dur + (iv.end - prev.end);
                        prev.end = iv.end;
                    }
                } else {
                    acc.push(iv);
                    prev = iv;
                    dur = dur + (iv.end - iv.start);
                }
            }
        }

        this.str = acc.map(formatInterval).join(', ');
        this.duration = dur;
        this.intervals = acc;
    }

    static parse(str) {
        try {
            return new TimeString(str);
        } catch (Err) {
            return null;
        }
    }

    /**
     * Checks that all intervals in other is contained in an interval of this TimeString
     * If either TimeString is invalid, the result is "undefined";
     * @param {TimeString} other
     */
    contains(other) {
        if (!(other instanceof TimeString)) return;

        this._closed = this._closed || this.intervals.filter(x => x.end != null);

        return other.intervals.every(oi => this._closed.some(ti => oi.start >= ti.start && (oi.end == null ? (oi.start <= ti.end) : (oi.end <= ti.end))));
    }

    toJSON() {
        return this.str;
    }
}
